// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"customBlocks-module--buttonContainer--TskHI","button":"customBlocks-module--button--3pS6J page-module--button--2LaRp"};